import { useEffect, useRef, useState } from "react";
import { Html5Qrcode, Html5QrcodeSupportedFormats } from "html5-qrcode";

export default function Scanner() {
  const scannerRef = useRef(null);
  const isRunningRef = useRef(false);

  const [codigo, setCodigo] = useState("");
  const [ativo, setAtivo] = useState(false);

  useEffect(() => {
    if (!ativo) return;

    if (scannerRef.current) return; // evita duplicar câmera

    const scanner = new Html5Qrcode("reader");
    scannerRef.current = scanner;

    scanner
      .start(
        {
          facingMode: "environment", // câmera traseira
        },
        {
          fps: 20, // velocidade melhor
          qrbox: { width: 300, height: 150 }, // área otimizada
          formatsToSupport: [
            Html5QrcodeSupportedFormats.EAN_13,
            Html5QrcodeSupportedFormats.CODE_128,
          ],
          videoConstraints: {
            facingMode: "environment",
            width: { ideal: 1280 },
            height: { ideal: 720 },
            advanced: [{ focusMode: "continuous" }], // tenta melhorar foco
          },
        },
        (decodedText) => {
          setCodigo(decodedText);

          if (isRunningRef.current) {
            scanner.stop().then(() => {
              isRunningRef.current = false;
              scannerRef.current = null;
              setAtivo(false);
            });
          }
        },
        () => {}
      )
      .then(() => {
        isRunningRef.current = true;
      })
      .catch((err) => {
        console.error("Erro ao iniciar câmera:", err);
      });

    return () => {
      if (isRunningRef.current && scannerRef.current) {
        scannerRef.current.stop().catch(() => {});
        isRunningRef.current = false;
        scannerRef.current = null;
      }
    };
  }, [ativo]);

  return (
    <div style={{ textAlign: "center" }}>
      <h2>Leitor de Código de Barras</h2>

      {!ativo && (
        <button onClick={() => setAtivo(true)}>
          Abrir Scanner
        </button>
      )}

      {ativo && (
        <>
          <div
            id="reader"
            style={{
              width: 320,
              margin: "auto",
              marginTop: 20,
            }}
          />

          <button
            style={{ marginTop: 10 }}
            onClick={() => setAtivo(false)}
          >
            Fechar
          </button>
        </>
      )}

      {codigo && (
        <div style={{ marginTop: 20 }}>
          <h3>Código lido:</h3>
          <p style={{ fontSize: 20 }}>{codigo}</p>
        </div>
      )}
    </div>
  );
}